<script lang="ts" setup>
defineOptions({
    name: 'IdeoFormSelectOption'
});

defineProps<{
    value: any;
    disabled?: boolean;
    hidden?: boolean;
}>();
</script>

<template>
    <slot name="default" />
</template>
